import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

import { Briefing } from "../../../shared/types";
import { BriefingHistoryModel } from "../../models/briefing-history.model";
import { BriefingFilterService } from "../../util/briefing-filter.service";
import { FilterPageOptionEnum } from "../../../shared/enums";

@Component({
	selector: "ic-briefing-history",
	templateUrl: "./briefing-history.component.html",
	styleUrls: ["./briefing-history.component.scss"],
	providers: [BriefingFilterService, BriefingHistoryModel],
	standalone: false,
})
export class BriefingHistoryComponent implements OnInit, OnDestroy {
	private readonly briefingModel = inject(BriefingHistoryModel);

	pageOption = FilterPageOptionEnum.BRIEFING_HISTORY;
	private readonly destroyed$ = new Subject<void>();

	readonly briefingHistory$: Observable<Briefing[]> = this.briefingModel.filteredBriefingHistory$;
	readonly loading$ = this.briefingModel.loading$;
	readonly hasActiveFilters$ = this.briefingModel.filter$.pipe(map((filters) => !!filters.length));

	ngOnInit() {
		this.briefingModel.selectFilter(this.pageOption);
		this.briefingModel.loadBriefingHistory().pipe(takeUntil(this.destroyed$)).subscribe();
	}

	search(search: string) {
		this.briefingModel.search(search);
	}

	ngOnDestroy() {
		this.destroyed$.next();
	}
}
